import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import ItemFooter from './ItemFooter'

import classes from './QuizView.module.scss'

const QuizQuestion = ({ question, pick, isLast, isSubmitting, onPick, onPrevious, onNext }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className={classes.prompt}>{question.prompt}</div>
      <div className='d-flex flex-column' role='radiogroup'>
        {question.answers.map(answer => (
          <button
            key={answer.id}
            type='button'
            role='radio'
            aria-checked={pick === answer.id}
            className={classNames('d-flex align-items-center text-left', classes.option, { [classes.optionSelected]: pick === answer.id })}
            onClick={() => onPick(answer.id)}
          >
            <span className={classNames('d-flex align-items-center justify-content-center', classes.dot)}><span /></span>
            {answer.text}
          </button>
        ))}
      </div>
      <ItemFooter
        onPrevious={onPrevious}
        nextLabel={t(isLast ? 'portal.certification.quiz.seeResults' : 'portal.certification.quiz.nextQuestion')}
        onNext={onNext}
        nextDisabled={pick === undefined}
        loading={isSubmitting}
      />
    </>
  )
}

QuizQuestion.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    prompt: PropTypes.string.isRequired,
    answers: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number.isRequired, text: PropTypes.string.isRequired })).isRequired,
  }).isRequired,
  pick: PropTypes.number,
  isLast: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onPick: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
}

export default QuizQuestion
